import React from 'react';
import {Show, TextField, ReferenceField, SimpleShowLayout, SingleFieldList, ArrayField, ImageField, ChipField} from 'react-admin';
import {HASHTAG_CATEGORY_LIST, HASHTAG_CATEGORY, HASH_TAG} from '../../consts/Names';
export const HashTagsForCategoryShow = (props) => {
   return (
      <Show title="Tags list for category details" {...props}>
         <SimpleShowLayout>
            <ReferenceField source={HASHTAG_CATEGORY_LIST.category_id} reference={HASHTAG_CATEGORY.SOURCE}>
               <TextField source={HASHTAG_CATEGORY.name} />
            </ReferenceField>
            <ImageField source={HASHTAG_CATEGORY_LIST.image} />
            <ArrayField label="Related tags" source={'tags'}>
               <SingleFieldList linkType={false}>
                  <ChipField source={HASH_TAG.name} />
               </SingleFieldList>
            </ArrayField>
         </SimpleShowLayout>
      </Show>
   );
};
